import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Faze.module.css';
import { Link } from "react-router-dom";


const FazeStateCard = ({card, position, count}) => {
    
    const { t } = useTranslation();

    const cardImageSrc = "https://es-europe.eu/data/client/card/card_" + card.name + ".jpg"

    return (
        <div className={[styles.fazeStateCard, styles.card].join(' ')}>
            <div className={styles.header}>
                <span className={styles.title}>{t("Karta")}</span>
                <span className={styles.progress}>{position}/{count}</span>
            </div>
            <div className={styles.content}>
                <div className={styles.text} dangerouslySetInnerHTML={{ __html: card.content }} />
                <img className={styles.image} src={cardImageSrc} alt={t("Ilustrace")} />
            </div>
            
            <div className={styles.footer}>
                <Link className={styles.button} to={'/faze/' + card.id}>
                    <span>{t("Číst více")}</span>
                    <i></i>
                </Link>
            </div>
        </div>
    )
};


export default FazeStateCard;